import VideoPlayer from './VideoPlayer';

// query helper
const queryEach = (selector, callback) => {
  if (selector instanceof Array) selector = selector.join(',');
  const nodes = document.querySelectorAll(selector);
  nodes.forEach(callback);
}

// If user has storage disabled, asume they have seen index
let hasSeenIndex = true;

if (storageAvailable()) {
  // If user's storage is enabled, asume they haven't seen the index
  hasSeenIndex = false;
  const FYAFStorage = localStorage.getItem('stlpr_living_ferguson');

  if (FYAFStorage) {
    const store = JSON.parse(FYAFStorage);
    // now we can determine if they've really seen it or not
    hasSeenIndex = store && store.visited_homepage;
  }
}

const config = {
  subtitles: data.transcript,
  speakers: data.speakers,
  sources: [data.audio],
  autoplay: true,
}

countdown = null;
const agentHasIOS= /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
const agentHasSafari = navigator.userAgent.indexOf("Safari") > -1;
// console.log('agentHasIOS', agentHasIOS);
// console.log('agentHasSafari', agentHasSafari);

isIOS = agentHasIOS && agentHasSafari;
player = new VideoPlayer(config);


if (!hasSeenIndex) {
  nextURL = 'index.html';
  // massive hack to support advancement to the index page
  // get selectors for appropriate modal components
  const title = '#overlay-next-landscape h3.vm_title, #overlay-next-portrait h3.vm_title';
  const subtitle = '.vm_title_supplement';
  const image = '.vm_image';
  const quote = '.vm_quote';
  const person = 'p.vm_title';
  const nextLink = '.vm_panel_action a, .vm_control_next';
  const previousLink = '.vm_control_previous';
  const skipLink = '.vm_box';
  const skipText = '.vm_line_single';
  const redundantSkip = '#overlay-next-landscape .vm_box, #overlay-next-portrait .vm_box';
  const skipTitle = '.vm_line_supplement';

  queryEach(title, el => el.innerText = 'Living #Ferguson: 5 Years After the Killing of Michael Brown Jr.');
  queryEach(subtitle, el => el.innerText = 'Home');
  queryEach(image, el => el.src = 'assets/photos/canfield.jpg');
  queryEach(skipText, el => el.innerText = 'Project Home');

  queryEach([nextLink, skipLink, previousLink], el => el.href = 'index.html');
  queryEach([quote, person, redundantSkip, skipTitle], el => el.style.display = 'none');
}

class ResponsiveBackgroundImage {

  constructor(element) {
    this.element = element;
    this.img = element.querySelector('img');
    this.src = '';

    this.img.addEventListener('load', () => {
      this.update();
    });

    if (this.img.complete) {
      this.update();
    }
  }

  update() {
    let src = typeof this.img.currentSrc !== 'undefined' ? this.img.currentSrc : this.img.src;
    if (this.src !== src) {
      this.src = src;
      this.element.style.backgroundImage = 'url("' + this.src + '")';

    }
  }
}

let elements = document.querySelectorAll('[data-video-image]');

responsiveImages = [];
for (let i = 0; i < elements.length; i++) {
  responsiveImages.push(new ResponsiveBackgroundImage(elements[i]));
}

formatImage = function (image, photo) {
  image.img.currentSrc = undefined;
  image.img.srcset = `
    ${photo}-320.jpg 320w,
    ${photo}-640.jpg 640w,
    ${photo}-1280.jpg 1280w,
    ${photo}-2560.jpg 2560w
  `;
  image.img.src = `${photo}-320.jpg`;
}